import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Marker } from '@xing-com/marker';

const StyledMarker = styled(Marker)`
  align-self: flex-start;
  flex-shrink: 0;
`;

export const NewPerkMarker = (): ReactElement => (
  <StyledMarker variant="strong">
    <FormattedMessage id="UPSELL_PURCHASE_PERK_LIST_NEW_MARKER" />
  </StyledMarker>
);
